import jwt_decode from "jwt-decode";

/**
 * Decodes JWT token and returns the payload
 * @param {string} token - JWT token to decode
 * @returns {object} Decoded token payload
 */
export const decodeJWTToken = (token) => {
    try {
        if (!token) {
            throw new Error("Token is required");
        }
        return jwt_decode(token);
    } catch (error) {
        console.error("Error decoding JWT token:", error);
        return null;
    }
};

/**
 * Extracts shop name from JWT token
 * Note: The JWT token uses 'sub' field to store the shop name (e.g., "hv-test5.myshopify.com")
 * @param {string} token - JWT token
 * @returns {string|null} Shop name from token or null if not found
 */
export const getShopNameFromToken = (token) => {
    try {
        const decoded = decodeJWTToken(token);
        if (decoded && decoded.sub) {
            return decoded.sub;
        }
        return null;
    } catch (error) {
        console.error("Error extracting shop name from token:", error);
        return null;
    }
};

/**
 * Validates if shop name from URL matches shop name in JWT token
 * @param {string} urlShopName - Shop name from URL parameter
 * @param {string} token - JWT token
 * @returns {boolean} True if shop names match, false otherwise
 */
export const validateJwtTokenShopNameWithUrlParamShopName = (urlShopName, token) => {
    try {
        const tokenShopName = getShopNameFromToken(token);
        if (!urlShopName || !tokenShopName) {
            return false;
        }
        return urlShopName.toLowerCase() === tokenShopName.toLowerCase();
    } catch (error) {
        console.error("Error validating shop name:", error);
        return false;
    }
};
